<template>
  <header class="app-header" :class="[
      {'app-header--active': showMobileMenu},
      `app-header--${headerTheme}`
    ]">
    <!-- Logo部分（PC和Mobile共用） -->
    <div class="app-header__logo" @click="goToHome">
      <img :src="domainConfig?.['siteIcon']" class="app-header__logo-icon" alt="">
      <div class="app-header__logo-text">
        {{domainConfig?.['siteName']}}
      </div>
    </div>

    <!-- PC导航菜单 (只在桌面设备显示) -->
    <nav class="app-header__nav" v-if="deviceType === 'desktop' || deviceType === 'pc'">
      <!-- Home -->
      <div class="app-header__nav-item"
        :class="{'app-header__nav-item--active': isRouteActive('/')}" @click="goToHome">
        <svg xmlns="http://www.w3.org/2000/svg" class="app-header__nav-icon" viewBox="0 0 14 14"
          fill="none">
          <path fill-rule="evenodd" clip-rule="evenodd"
            d="M3.26667 14C1.46832 14 0 12.5595 0 10.7698V6.12533C0 5.13168 0.462285 4.19501 1.25079 3.58353L4.98412 0.688408C6.16775 -0.229469 7.83225 -0.229469 9.01588 0.688408L12.7492 3.58353C13.5377 4.19501 14 5.13168 14 6.12533V10.7698C14 12.5595 12.5317 14 10.7333 14H3.26667ZM5.55609 1.42596C6.40309 0.769125 7.59691 0.769125 8.44391 1.42596L12.1772 4.32108C12.74 4.75746 13.0667 5.42292 13.0667 6.12533V10.7698C13.0667 12.0326 12.0278 13.0667 10.7333 13.0667H9.8V9.8C9.8 8.25361 8.54639 7 7 7C5.45361 7 4.2 8.25361 4.2 9.8V13.0667H3.26667C1.97223 13.0667 0.933333 12.0326 0.933333 10.7698V6.12533C0.933333 5.42292 1.26002 4.75746 1.82274 4.32108L5.55609 1.42596ZM5.13333 13.0667H8.86667V9.8C8.86667 8.76906 8.03094 7.93333 7 7.93333C5.96906 7.93333 5.13333 8.76906 5.13333 9.8V13.0667Z" />
        </svg>
        <span>Home</span>
      </div>

      <!-- Name Generator -->
      <div class="app-header__nav-item"
        :class="{'app-header__nav-item--active': isRouteActive('/names')}"
        @click="navigateToPage('/names')">
        <svg xmlns="http://www.w3.org/2000/svg" class="app-header__nav-icon" viewBox="0 0 14 14"
          fill="none">
          <path fill-rule="evenodd" clip-rule="evenodd"
            d="M2.31092 0.935355C1.7967 0.916377 1.45826 1.04336 1.25074 1.25088C1.04323 1.45839 0.916243 1.79683 0.93522 2.31107C0.954228 2.82613 1.12013 3.46913 1.44036 4.20378C1.71415 4.83189 2.09338 5.51017 2.56698 6.20994C3.07553 5.56235 3.65009 4.91361 4.28178 4.28193C4.91348 3.65022 5.56222 3.07566 6.20979 2.56711C5.51005 2.09351 4.83177 1.71428 4.20366 1.44049C3.469 1.12026 2.826 0.954362 2.31092 0.935355ZM7.00007 1.97861C6.16448 1.39019 5.34338 0.91914 4.57659 0.584908C3.77892 0.237198 3.01699 0.0274399 2.34534 0.00265287C1.67285 -0.0221645 1.04277 0.138913 0.590775 0.590909C0.138778 1.04291 -0.0223019 1.67298 0.00251788 2.34549C0.0273026 3.01711 0.237063 3.77904 0.584771 4.57674C0.919003 5.3435 1.39006 6.1646 1.97849 7.0002C1.39006 7.83579 0.919003 8.65689 0.584771 9.42365C0.237061 10.2214 0.0273026 10.9833 0.00251554 11.6549C-0.0223019 12.3274 0.138776 12.9575 0.590775 13.4095C1.04277 13.8615 1.67285 14.0225 2.34534 13.9977C3.01699 13.9729 3.77892 13.7632 4.57659 13.4155C5.34338 13.0813 6.16448 12.6102 7.00007 12.0218C7.83564 12.6102 8.65675 13.0813 9.42353 13.4155C10.2212 13.7632 10.9831 13.9729 11.6548 13.9977C12.3273 14.0225 12.9574 13.8615 13.4093 13.4095C13.8614 12.9575 14.0224 12.3274 13.9976 11.6549C13.9728 10.9833 13.7631 10.2214 13.4154 9.42365C13.0811 8.65689 12.6101 7.83579 12.0216 7.0002C12.6101 6.1646 13.0811 5.3435 13.4154 4.57674C13.7631 3.77904 13.9728 3.01711 13.9976 2.34549C14.0224 1.67298 13.8614 1.04291 13.4093 0.590911C12.9574 0.138913 12.3273 -0.0221645 11.6548 0.00265287C10.9831 0.0274399 10.2212 0.237198 9.42353 0.584908C8.65675 0.91914 7.83564 1.39019 7.00007 1.97861ZM7.00007 3.13572C6.3154 3.65752 5.62077 4.26286 4.94174 4.94189C4.26274 5.62089 3.6574 6.31553 3.13559 7.0002C3.6574 7.68487 4.26274 8.37948 4.94174 9.05851C5.62077 9.73753 6.3154 10.3428 7.00007 10.8647C7.68472 10.3428 8.37936 9.73753 9.05839 9.05851C9.73739 8.37948 10.3427 7.68487 10.8645 7.0002C10.3427 6.31553 9.73739 5.62089 9.05839 4.94189C8.37936 4.26286 7.68475 3.65752 7.00007 3.13572ZM11.4331 6.20994C10.9246 5.56235 10.3501 4.91361 9.71835 4.28193C9.08664 3.65022 8.4379 3.07566 7.79033 2.56711C8.49008 2.09351 9.16838 1.71428 9.79647 1.44049C10.5311 1.12026 11.1741 0.954362 11.6892 0.935355C12.2034 0.916377 12.5419 1.04336 12.7494 1.25088C12.9569 1.45839 13.0839 1.79683 13.0649 2.31107C13.0459 2.82613 12.88 3.46913 12.5598 4.20378C12.286 4.83189 11.9068 5.51017 11.4331 6.20994ZM11.4331 7.79045C10.9246 8.43803 10.3501 9.08679 9.71835 9.71847C9.08664 10.3502 8.4379 10.9247 7.79033 11.4333C8.49008 11.9069 9.16838 12.2861 9.79647 12.5599C10.5311 12.8801 11.1741 13.046 11.6892 13.065C12.2034 13.084 12.5419 12.957 12.7494 12.7495C12.9569 12.542 13.0839 12.2035 13.0649 11.6893C13.0459 11.1743 12.88 10.5312 12.5598 9.79661C12.286 9.1685 11.9068 8.49022 11.4331 7.79045ZM6.20979 11.4333C5.56222 10.9247 4.91348 10.3502 4.28178 9.71847C3.65009 9.08679 3.07553 8.43803 2.56698 7.79045C2.09338 8.4902 1.71415 9.1685 1.44036 9.79661C1.12013 10.5312 0.954225 11.1743 0.935218 11.6893C0.916241 12.2035 1.04323 12.542 1.25074 12.7495C1.45826 12.957 1.7967 13.084 2.31092 13.065C2.826 13.046 3.469 12.8801 4.20366 12.5599C4.83177 12.2861 5.51005 11.9069 6.20979 11.4333ZM7.00007 5.8335C6.35574 5.8335 5.8334 6.35585 5.8334 7.00017C5.8334 7.6445 6.35574 8.16684 7.00007 8.16684C7.6444 8.16684 8.16675 7.6445 8.16675 7.00017C8.16675 6.35585 7.6444 5.8335 7.00007 5.8335ZM4.90007 7.00017C4.90007 5.84036 5.84026 4.90017 7.00007 4.90017C8.15989 4.90017 9.10008 5.84036 9.10008 7.00017C9.10008 8.15998 8.15989 9.10018 7.00007 9.10018C5.84026 9.10018 4.90007 8.15998 4.90007 7.00017Z" />
        </svg>
        <span>Name Generator</span>
      </div>

      <!-- Names by Gender -->
      <div class="app-header__nav-item app-header__nav-item--has-dropdown"
        :class="{'app-header__nav-item--active': isRouteActive('/categories/gender')}"
        @click="toggleDropdown('gender')" ref="genderNavItem">
        <svg xmlns="http://www.w3.org/2000/svg" class="app-header__nav-icon" viewBox="0 0 14 14"
          fill="none">
          <path fill-rule="evenodd" clip-rule="evenodd"
            d="M0.466667 10.5C0.208934 10.5 0 10.7089 0 10.9667C0 11.2244 0.208934 11.4333 0.466667 11.4333H1.4V12.6C1.4 13.3732 2.0268 14 2.8 14H6.06667C6.83986 14 7.46667 13.3732 7.46667 12.6V9.33333C7.46667 8.56014 6.83986 7.93333 6.06667 7.93333H2.8C2.0268 7.93333 1.4 8.56014 1.4 9.33333V10.5H0.466667ZM2.33333 12.6V9.33333C2.33333 9.07559 2.54226 8.86667 2.8 8.86667H6.06667C6.32441 8.86667 6.53333 9.07559 6.53333 9.33333V12.6C6.53333 12.8577 6.32441 13.0667 6.06667 13.0667H2.8C2.54226 13.0667 2.33333 12.8577 2.33333 12.6Z" />
          <path
            d="M8.63333 10.5C8.37559 10.5 8.16667 10.7089 8.16667 10.9667C8.16667 11.2244 8.37559 11.4333 8.63333 11.4333H13.5333C13.7911 11.4333 14 11.2244 14 10.9667C14 10.7089 13.7911 10.5 13.5333 10.5H8.63333Z" />
          <path
            d="M5.36667 2.56667C5.62441 2.56667 5.83333 2.77559 5.83333 3.03333C5.83333 3.29107 5.62441 3.5 5.36667 3.5H0.466667C0.208934 3.5 0 3.29107 0 3.03333C0 2.77559 0.208934 2.56667 0.466667 2.56667H5.36667Z" />
          <path fill-rule="evenodd" clip-rule="evenodd"
            d="M14 3.03333C14 2.77559 13.7911 2.56667 13.5333 2.56667H12.6V1.4C12.6 0.626801 11.9732 0 11.2 0H7.93333C7.16014 0 6.53333 0.626801 6.53333 1.4V4.66667C6.53333 5.43986 7.16014 6.06667 7.93333 6.06667H11.2C11.9732 6.06667 12.6 5.43986 12.6 4.66667V3.5H13.5333C13.7911 3.5 14 3.29107 14 3.03333ZM11.2 5.13333C11.4577 5.13333 11.6667 4.92441 11.6667 4.66667V1.4C11.6667 1.14227 11.4577 0.933333 11.2 0.933333H7.93333C7.67559 0.933333 7.46667 1.14227 7.46667 1.4V4.66667C7.46667 4.92441 7.67559 5.13333 7.93333 5.13333H11.2Z" />
        </svg>
        <span>Names by Gender</span>
        <!-- Gender下拉菜单 -->
        <div class="app-header__dropdown app-header__dropdown--gender"
          v-if="activeDropdown === 'gender'" ref="genderDropdown">
          <div class="app-header__dropdown-menu app-header__dropdown-menu--gender">
            <div class="app-header__dropdown-item" v-for="item in genderItems" :key="item.value"
              @click="navigateToCategory('gender', item.value)">
              {{ item.label }}
            </div>
          </div>
        </div>
      </div>

      <!-- Names by Style -->
      <div class="app-header__nav-item app-header__nav-item--has-dropdown"
        :class="{'app-header__nav-item--active': isRouteActive('/categories/style')}"
        @click="toggleDropdown('style')" ref="styleNavItem">
        <svg xmlns="http://www.w3.org/2000/svg" class="app-header__nav-icon" viewBox="0 0 14 14"
          fill="none">
          <path fill-rule="evenodd" clip-rule="evenodd"
            d="M5.6202 0.00623703C6.64948 -0.0543106 7.65555 0.32819 8.38462 1.05727L12.9427 5.6154C14.3524 7.02506 14.3524 9.3106 12.9427 10.7203L10.7203 12.9427C9.3106 14.3524 7.02506 14.3524 5.6154 12.9427L1.05727 8.38462C0.32819 7.65555 -0.0543106 6.64948 0.00623703 5.6202L0.239078 1.66189C0.284158 0.89554 0.89554 0.284158 1.66189 0.239078L5.6202 0.00623703ZM7.72466 1.71723C7.1841 1.17667 6.43815 0.893069 5.67501 0.93796L1.71669 1.1708C1.42267 1.1881 1.1881 1.42267 1.1708 1.71669L0.93796 5.67501C0.893069 6.43815 1.17667 7.1841 1.71723 7.72466L6.27536 12.2828C7.32055 13.3279 9.01513 13.328 10.0603 12.2828L12.2828 10.0603C13.328 9.01513 13.328 7.32055 12.2828 6.27536L7.72466 1.71723ZM6.17101 4.2381C5.63724 3.70433 4.77185 3.70433 4.2381 4.2381C3.70433 4.77185 3.70433 5.63724 4.2381 6.17101C4.77185 6.70476 5.63724 6.70476 6.17101 6.17101C6.70476 5.63724 6.70476 4.77185 6.17101 4.2381ZM3.57814 3.57814C4.47638 2.67988 5.93273 2.67988 6.83097 3.57814C7.72921 4.47638 7.72921 5.93273 6.83097 6.83097C5.93273 7.72921 4.47638 7.72921 3.57814 6.83097C2.67988 5.93273 2.67988 4.47638 3.57814 3.57814Z"
            fill="white" />
        </svg>
        <span>Names by Style</span>
        <!-- Style下拉菜单 -->
        <div class="app-header__dropdown app-header__dropdown--style"
          v-if="activeDropdown === 'style'" ref="styleDropdown">
          <div class="app-header__dropdown-menu app-header__dropdown-menu--grid">
            <div class="app-header__dropdown-item" v-for="item in styleItems" :key="item.value"
              @click="navigateToCategory('style', item.value)">
              {{ item.label }}
            </div>
          </div>
        </div>
      </div>

      <!-- Names by Meaning -->
      <div class="app-header__nav-item app-header__nav-item--has-dropdown"
        :class="{'app-header__nav-item--active': isRouteActive('/categories/meaning')}"
        @click="toggleDropdown('meaning')" ref="meaningNavItem">
        <svg xmlns="http://www.w3.org/2000/svg" class="app-header__nav-icon" viewBox="0 0 14 14"
          fill="none">
          <path fill-rule="evenodd" clip-rule="evenodd"
            d="M4.14797 1.63333C3.93575 0.698138 3.09941 0 2.1 0C0.940203 0 0 0.940203 0 2.1C0 3.25981 0.940203 4.2 2.1 4.2C3.09941 4.2 3.93575 3.50187 4.14797 2.56667H8.4C8.65774 2.56667 8.86667 2.35774 8.86667 2.1C8.86667 1.84227 8.65774 1.63333 8.4 1.63333H4.14797ZM3.26667 2.09944V2.1C3.26667 2.74433 2.74433 3.26667 2.1 3.26667C1.45567 3.26667 0.933333 2.74433 0.933333 2.1C0.933333 1.45567 1.45567 0.933333 2.1 0.933333C2.74414 0.933333 3.26636 1.45537 3.26667 2.09944Z" />
          <path fill-rule="evenodd" clip-rule="evenodd"
            d="M12.3667 4.14797C13.3019 3.93575 14 3.09941 14 2.1C14 0.940203 13.0598 0 11.9 0C10.7402 0 9.8 0.940203 9.8 2.1C9.8 3.09941 10.4981 3.93575 11.4333 4.14797V8.4C11.4333 8.65774 11.6423 8.86667 11.9 8.86667C12.1577 8.86667 12.3667 8.65774 12.3667 8.4V4.14797ZM11.9 3.26667C12.5443 3.26667 13.0667 2.74433 13.0667 2.1C13.0667 1.45567 12.5443 0.933333 11.9 0.933333C11.2557 0.933333 10.7333 1.45567 10.7333 2.1C10.7333 2.74433 11.2557 3.26667 11.9 3.26667Z" />
          <path fill-rule="evenodd" clip-rule="evenodd"
            d="M9.85203 11.4333H5.6C5.34226 11.4333 5.13333 11.6423 5.13333 11.9C5.13333 12.1577 5.34226 12.3667 5.6 12.3667H9.85203C10.0642 13.3019 10.9006 14 11.9 14C13.0598 14 14 13.0598 14 11.9C14 10.7402 13.0598 9.8 11.9 9.8C10.9006 9.8 10.0642 10.4981 9.85203 11.4333ZM10.7333 11.9C10.7333 12.5443 11.2557 13.0667 11.9 13.0667C12.5443 13.0667 13.0667 12.5443 13.0667 11.9C13.0667 11.2557 12.5443 10.7333 11.9 10.7333C11.2557 10.7333 10.7333 11.2557 10.7333 11.9Z" />
          <path fill-rule="evenodd" clip-rule="evenodd"
            d="M2.56667 9.85203V5.6C2.56667 5.34226 2.35774 5.13333 2.1 5.13333C1.84227 5.13333 1.63333 5.34226 1.63333 5.6V9.85203C0.698138 10.0642 0 10.9006 0 11.9C0 13.0598 0.940203 14 2.1 14C3.25981 14 4.2 13.0598 4.2 11.9C4.2 10.9006 3.50187 10.0642 2.56667 9.85203ZM2.1 10.7333C1.45567 10.7333 0.933333 11.2557 0.933333 11.9C0.933333 12.5443 1.45567 13.0667 2.1 13.0667C2.74433 13.0667 3.26667 12.5443 3.26667 11.9C3.26667 11.2557 2.74433 10.7333 2.1 10.7333Z" />
        </svg>
        <span>Names by Meaning</span>
        <!-- Meaning下拉菜单 -->
        <div class="app-header__dropdown app-header__dropdown--meaning"
          v-if="activeDropdown === 'meaning'" ref="meaningDropdown">
          <div class="app-header__dropdown-menu app-header__dropdown-menu--grid">
            <div class="app-header__dropdown-item" v-for="item in meaningItems" :key="item.value"
              @click="navigateToCategory('meaning', item.value)">
              {{ item.label }}
            </div>
          </div>
        </div>
      </div>
    </nav>

    <!-- Mobile菜单按钮 (只在移动设备显示) -->
    <div class="app-header__mobile-trigger" v-if="deviceType === 'mobile'"
      @click="toggleMobileMenu">
      <img :class="{'close': showMobileMenu}"
        :src="showMobileMenu ? require('@/assets/default/menu-icon-close.svg') : require('@/assets/default/menu-icon.svg')"
        alt="">
    </div>

    <!-- Mobile菜单 (显示/隐藏取决于showMobileMenu) -->
    <div class="app-header__mobile-menu-row" v-if="showMobileMenu && deviceType === 'mobile'">
      <div class="app-header__mobile-menu">
        <!-- 顶部导航按钮 -->
        <div class="app-header__mobile-menu-nav">
          <div class="app-header__mobile-menu-nav-item app-header__mobile-menu-nav-item--active"
            :class="{'app-header__mobile-menu-nav-item--active': isRouteActive('/')}"
            @click="goToHome">
            <img src="@/assets/default/home-icon.svg" alt="">
            <span>Home</span>
          </div>
          <div class="app-header__mobile-menu-nav-item app-header__mobile-menu-nav-item--active"
            :class="{'app-header__mobile-menu-nav-item--active': isRouteActive('/names')}"
            @click="navigateToPage('/names')">
            <img src="@/assets/icons/generate-icon.svg" alt="">
            <span>Name Generator</span>
          </div>
        </div>

        <div class="app-header__mobile-menu-divider"></div>

        <!-- Names by Gender 部分 -->
        <div class="app-header__mobile-menu-section">
          <div class="app-header__mobile-menu-title">
            <img src="@/assets/icons/gender.svg" alt="">
            <span>Names by Gender</span>
          </div>
          <div class="app-header__mobile-menu-items app-header__mobile-menu-items--gender">
            <div class="app-header__mobile-menu-item" v-for="item in genderItems" :key="item.value"
              @click="navigateToCategory('gender', item.value)">
              <span>{{ item.label }}</span>
            </div>
          </div>
        </div>

        <div class="app-header__mobile-menu-divider"></div>

        <!-- Names by Style 部分 -->
        <div class="app-header__mobile-menu-section">
          <div class="app-header__mobile-menu-title">
            <img src="@/assets/icons/style.svg" alt="">
            <span>Names by Style</span>
          </div>
          <div class="app-header__mobile-menu-items">
            <div class="app-header__mobile-menu-grid">
              <div class="app-header__mobile-menu-item" v-for="item in styleItems" :key="item.value"
                @click="navigateToCategory('style', item.value)">
                <span>{{ item.label }}</span>
              </div>
            </div>
          </div>
        </div>

        <div class="app-header__mobile-menu-divider"></div>

        <!-- Names by Meaning 部分 -->
        <div class="app-header__mobile-menu-section">
          <div class="app-header__mobile-menu-title">
            <img src="@/assets/icons/meaning.svg" alt="">
            <span>Names by Meaning</span>
          </div>
          <div class="app-header__mobile-menu-items">
            <div class="app-header__mobile-menu-grid">
              <div class="app-header__mobile-menu-item" v-for="item in meaningItems"
                :key="item.value" @click="navigateToCategory('meaning', item.value)">
                <span>{{ item.label }}</span>
              </div>
            </div>
          </div>
        </div>

        <div class="app-header__mobile-menu-divider"></div>

        <!-- 底部链接 -->
        <div class="app-header__mobile-menu-links">
          <div class="app-header__mobile-menu-link" @click="navigateToPage('/categories')">
            <div>
              <span>Categories</span>
            </div>
            <img src="@/assets/default/arrow-right-small.svg"
              class="app-header__mobile-menu-link-arrow" alt="">
          </div>
          <div class="app-header__mobile-menu-link" @click="navigateToPage('/about-us')">
            <div>
              <span>About us</span>
            </div>
            <img src="@/assets/default/arrow-right-small.svg"
              class="app-header__mobile-menu-link-arrow" alt="">
          </div>
          <div class="app-header__mobile-menu-link" @click="navigateToPage('/terms-of-service')">
            <div>
              <span>Terms of Services</span>
            </div>
            <img src="@/assets/default/arrow-right-small.svg"
              class="app-header__mobile-menu-link-arrow" alt="">
          </div>
          <div class="app-header__mobile-menu-link" @click="navigateToPage('/privacy-policy')">
            <div>
              <span>Privacy Policy</span>
            </div>
            <img src="@/assets/default/arrow-right-small.svg"
              class="app-header__mobile-menu-link-arrow" alt="">
          </div>
          <div class="app-header__mobile-menu-link" @click="navigateToPage('/disclaimer')">
            <div>
              <span>Disclaimer</span>
            </div>
            <img src="@/assets/default/arrow-right-small.svg"
              class="app-header__mobile-menu-link-arrow" alt="">
          </div>
        </div>
      </div>
    </div>
  </header>
</template>

<script>
import { mapGetters } from 'vuex';

export default {
  name: 'AppHeader',
  components: {
  },
  props: {
    headerTheme: {
      type: String,
      default: 'light' // 可选值：'light'或'dark'
    },
  },
  computed: {
    ...mapGetters({
      deviceType: 'deviceType',
      domainConfig: 'domainConfig',
      gender: 'gender',
      style: 'style',
      meaning: 'meaning'
    }),
    genderItems () {
      if (!this.gender || this.gender.length === 0) return [];
      return this.gender.map(item => ({ label: item, value: item.toLowerCase() }));
    },
    styleItems () {
      if (!this.style || this.style.length === 0) return [];
      return this.style.map(item => ({ label: item, value: item.toLowerCase() }));
    },
    meaningItems () {
      if (!this.meaning || this.meaning.length === 0) return [];
      return this.meaning.map(item => ({ label: item, value: item.toLowerCase() }));
    },
  },
  data () {
    return {
      showMobileMenu: false,
      activeDropdown: null,
    };
  },
  methods: {
    toggleMobileMenu () {
      this.showMobileMenu = !this.showMobileMenu;

      // 如果打开菜单，禁止body滚动
      if (this.showMobileMenu) {
        document.body.style.overflow = 'hidden';
        document.body.style.height = '100%';
        document.body.style.position = 'fixed';
        document.body.style.width = '100%';
      } else {
        document.body.style.overflow = '';
        document.body.style.height = '';
        document.body.style.position = '';
        document.body.style.width = '';
      }
    },

    toggleDropdown (type) {
      if (this.activeDropdown === type) {
        this.activeDropdown = null;
      } else {
        this.activeDropdown = type;
      }
    },

    // 判断当前路由是否激活
    isRouteActive (link) {
      let currentPath = this.$route.path;
      const channel = this.$route.params.channel;

      if (channel && currentPath.startsWith(`/${channel}`)) {
        currentPath = currentPath.replace(`/${channel}`, '') || '/';
      }

      if (link === '/' && (currentPath === '/' || currentPath === '')) {
        return true;
      }

      if (link === '/' && currentPath !== '/') {
        return false;
      }

      return currentPath.startsWith(link);
    },

    goToHome () {
      if (this.$route.path !== '/') {
        if (this.$route.params.channel) {
          window.location.href = `/${this.$route.params.channel}`;
        } else {
          this.$router.push({ path: '/' });
        }
      }
    },

    navigateToPage (path) {
      if (this.$route.params.channel) {
        this.$router.push(`/${this.$route.params.channel}${path}`);
      } else {
        this.$router.push(path);
      }
    },

    navigateToCategory (cate, value) {
      const path = `/categories/${cate}/${value}`;
      this.navigateToPage(path);
      this.activeDropdown = null;
    },

    handleClickOutside (event) {
      if (!this.activeDropdown) return;

      const target = event.target;
      const isClickInside = (refName) => {
        const ref = this.$refs[refName];
        return ref && (ref === target || ref.contains(target));
      }

      if (!isClickInside(`${this.activeDropdown}NavItem`) && !isClickInside(`${this.activeDropdown}Dropdown`)) {
        this.activeDropdown = null;
      }
    },
  },
  beforeDestroy () {
    document.body.style.overflow = '';
    document.body.style.height = '';
    document.body.style.position = '';
    document.body.style.width = '';
    document.removeEventListener('click', this.handleClickOutside);
  },
  mounted () {
    this.$router.afterEach(() => {
      if (this.showMobileMenu) {
        this.showMobileMenu = false;
        document.body.style.overflow = '';
        document.body.style.height = '';
        document.body.style.position = '';
        document.body.style.width = '';
      }
      this.activeDropdown = null;
    });
    document.addEventListener('click', this.handleClickOutside);
  }
};
</script>

<style lang="scss">
@import '~@/css/variables.scss';

.app-header {
	display: flex;
	flex-direction: row;
	align-items: center;
	justify-content: space-between;
	position: relative;
	width: 100%;
	box-sizing: border-box;
	background-color: #a31984;
	z-index: 100;
	height: rem(60);

	&--light {
		color: #ffffff;
	}

	&--dark {
		color: #ffffff;
	}

	&__logo {
		display: flex;
		flex-direction: row;
		gap: rem(16);
		align-items: center;
		justify-content: flex-start;
		flex-shrink: 0;
		position: relative;
		cursor: pointer;
		padding: rem(16) 0;
		font-family: 'Aboreto';

		&-icon {
			flex-shrink: 0;
			width: rem(36);
			height: rem(36);
			position: relative;
			overflow: visible;
		}

		&-text {
			color: #ffffff;
			text-align: left;
			font-size: rem(28);
			line-height: rem(28);
			font-weight: 400;
			text-transform: uppercase;
			position: relative;
		}
	}

	&__nav {
		display: flex;
		flex-direction: row;
		gap: rem(8);
		align-items: center;
		justify-content: flex-start;
		flex-shrink: 0;
		position: relative;
		height: 100%;

		&-icon {
			flex-shrink: 0;
			width: rem(14);
			height: rem(14);
			position: relative;
			overflow: visible;
			path {
				fill: #fff;
			}
		}

		&-item {
			display: flex;
			flex-direction: row;
			gap: rem(8);
			align-items: center;
			justify-content: flex-start;
			flex-shrink: 0;
			position: relative;
			cursor: pointer;
			height: rem(14);
			transition: all 0.3s;
			border-radius: rem(12);
			padding: rem(8) rem(12);
			box-sizing: content-box;

			span {
				color: #ffffff;
				text-align: left;
				font-size: rem(14);
				line-height: rem(14);
				font-weight: 400;
				position: relative;
			}

			&:hover {
				background: rgba(255, 255, 255, 0.2);
				span {
					color: #ffffff;
				}
				.app-header__nav-icon {
					path {
						fill: #fff;
					}
				}
			}
			&--active {
				background: rgba(255, 255, 255, 1);
				span {
					font-weight: 900;
					color: var(--theme-primary);
				}

				.app-header__nav-icon {
					path {
						fill: #a31984;
					}
				}
			}

			&--has-dropdown {
				position: relative;
			}
		}
	}

	&__dropdown {
		position: absolute;
		top: calc(100% + 4px);
		left: 50%;
		transform: translateX(-50%);
		z-index: 1000;

		&-menu {
			background: #a31984;
			border-radius: rem(20);
			padding: rem(16);
			display: flex;
			flex-direction: column;
			gap: rem(8);
			box-shadow: 0px 4px 8px 0px rgba(0, 0, 0, 0.16);

			&--gender {
				width: rem(200);
			}

			&--grid {
				display: grid;
				grid-template-columns: repeat(2, 1fr);
				gap: rem(8);
				width: rem(300);
			}
		}

		&-item {
			background: rgba(255, 255, 255, 0.2);
			border-radius: rem(20);
			padding: rem(12) rem(16);
			color: #ffffff;
			font-size: rem(14);
			line-height: rem(14);
			font-weight: 600;
			cursor: pointer;
			text-align: center;
			transition: background-color 0.3s ease, color 0.3s ease;

			&:hover {
				background-color: #ffffff;
				color: #a31984;
			}
		}
	}

	&__mobile-trigger {
		flex-shrink: 0;
		width: rem(28);
		height: rem(28);
		position: relative;
		overflow: visible;
		cursor: pointer;
		display: flex;
		align-items: center;
		justify-content: center;

		img {
			width: rem(28);
			height: rem(28);
		}

		.close {
			width: rem(16);
			height: rem(16);
		}
	}

	&__mobile-menu-row {
		position: fixed;
		top: rem(60);
		height: calc(100vh - rem(60));
		left: 0;
		width: 100%;
		background: rgba(0, 0, 0, 0.5);
		z-index: 99;
	}

	&__mobile-menu {
		width: 100%;
		height: 95%;
		overflow: auto;
		background: linear-gradient(180deg, rgba(163, 25, 132, 1) 0%, rgba(163, 25, 132, 0.8) 100%);
		box-shadow: 0px 4px 8px 0px rgba(0, 0, 0, 0.16);
		backdrop-filter: blur(5px);
		display: flex;
		flex-direction: column;
		padding: rem(32) rem(16);
		gap: rem(16);

		&-nav {
			display: flex;
			flex-direction: row;
			gap: rem(12);
			align-items: flex-start;
			justify-content: flex-start;
			width: 100%;

			&-item {
				background: rgba(255, 255, 255, 0.2);
				border-radius: rem(100);
				padding: rem(12) rem(16);
				display: flex;
				flex-direction: row;
				gap: rem(8);
				align-items: center;
				justify-content: center;
				flex: 1;
				cursor: pointer;

				img {
					width: rem(14);
					height: rem(14);
				}

				span {
					color: #ffffff;
					font-size: rem(13);
					line-height: rem(14);
					font-weight: 400;
				}

				&--active {
					background: #ffffff;
					span {
						color: #a31984;
						font-weight: 600;
					}
				}
			}
		}

		&-section {
			display: flex;
			flex-direction: column;
			gap: rem(12);
		}

		&-title {
			display: flex;
			flex-direction: row;
			gap: rem(8);
			align-items: center;
			padding: 0 rem(8);

			img {
				width: rem(14);
				height: rem(14);
			}

			span {
				color: #fff;
				font-size: rem(13);
				line-height: rem(14);
				font-weight: 400;
			}
		}

		&-items {
			display: flex;
			flex-direction: column;
			gap: rem(12);

			&--gender {
				flex-direction: row;
				.app-header__mobile-menu-item {
					flex: 1;
				}
			}
		}

		&-grid {
			display: flex;
			flex-direction: row;
			flex-wrap: wrap;
			gap: rem(12);
		}

		&-item {
			background: rgba(255, 255, 255, 0.2);
			border-radius: rem(100);
			padding: rem(12) rem(24);
			display: flex;
			align-items: center;
			justify-content: center;
			flex: 1 0 calc(50% - rem(6));
			cursor: pointer;
			text-align: center;

			span {
				color: #fff;
				font-size: rem(14);
				line-height: rem(14);
				font-weight: 600;
			}
		}

		&-divider {
			border-style: dashed;
			border-color: rgba(255, 255, 255, 0.2);
			border-width: 1px;
			width: 100%;
			height: 1px;
		}

		&-links {
			display: flex;
			flex-direction: column;
			gap: rem(12);
		}

		&-link {
			border-radius: rem(100);
			border: 1px solid rgba(255, 255, 255, 0.2);
			padding: rem(12) rem(24);
			display: flex;
			flex-direction: row;
			align-items: center;
			justify-content: space-between;
			cursor: pointer;

			div {
				display: flex;
				flex-direction: row;
				gap: rem(8);
				align-items: center;
			}

			img {
				width: rem(20);
				height: rem(20);
			}

			span {
				color: #fff;
				font-size: rem(13);
				line-height: rem(14);
				font-weight: 400;
			}

			&-arrow {
				width: rem(6);
				height: rem(10);
			}
		}
	}

	&--active {
		background: #a31984;
	}
}

.detect_deviece_pc,
.detect_deviece_desktop {
	.app-header {
		padding: 0 rem(180);
	}
}

.detect_deviece_mobile {
	.app-header {
		padding: rem(10) rem(16);
		background: #a31984;
		height: rem(60) !important;

		&--active {
			background: #a31984 !important;
		}
		&__logo {
			max-width: 80%;
		}

		&__logo-text {
			font-size: rem(18);
			line-height: rem(18);
			font-weight: 900;
			text-transform: uppercase;
			position: relative;
			overflow: hidden;
			display: -webkit-box;
			text-overflow: ellipsis;
			-webkit-line-clamp: 2;
			-webkit-box-orient: vertical;
		}
	}
}
</style>

